define('views/modules/feedback/blocks/comment',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/info-section',
    'views/parts/form/textarea',
    // templates
    'text!templates/modules/feedback/blocks/comment.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VInfoSection,
    VTextarea,
    // templates
    TFeedbackComment
) {

    var VFeedbackComment = Backbone.View.extend({
        template: TFeedbackComment,
        regions: {
            comment: "#feedback-comment"
        },

        initialize: function() {

            // namespace views inside an object.
            this.view = {
                info: new VInfoSection({
                    title: "Additional comment",
                    icon: "sl-icon-bubble",
                    content: this.template,
                }),
                comment: new VTextarea({
                    label: 'Write a message to your coach',
                    attribute: 'feedback_comment',
                    labelposition: 'outer',
                    rows: 3,
                    model: this.model
                })
            };
        },

        render: function() {
            // Insert Info Section rendered inside this view
            this.assign(this.view.info, this.$el)
                .generateZones()
                .assign(this.view.comment, this.zone.$comment);
            return this;
        },

        toggleDisabled: function(val) {
            this.view.comment.toggleDisabled(val);
            this.$el.toggleClass("disabled", val);
        }
    });

    return VFeedbackComment;
});

